/**
 * 전역 재생 일시정지 / 재개 신호
 *
 * NPC 타이핑, 오디오 재생(StepAudioPlayer), 홀드 타이머(자동 advance)가
 * 모두 한 신호에 맞춰 일시정지·재개되도록 중앙화한다.
 *
 * 일시정지는 녹화 모드와 일반 모드 양쪽에서 모두 작동해야 함.
 */

const EVENT_NAME = 'npc-playback-pause-changed';

// 모듈 지역 상태 — 새로 구독하는 컴포넌트가 최초 값을 바로 읽을 수 있게
let paused = false;

export function isPlaybackPaused() {
  return paused;
}

export function setPlaybackPaused(next) {
  if (typeof window === 'undefined') return;
  paused = !!next;
  window.dispatchEvent(
    new CustomEvent(EVENT_NAME, { detail: { paused } })
  );
}

export function togglePlaybackPaused() {
  setPlaybackPaused(!paused);
}

export function onPlaybackPauseChange(handler) {
  if (typeof window === 'undefined') return () => {};
  const listener = (e) => handler(e.detail.paused);
  window.addEventListener(EVENT_NAME, listener);
  return () => window.removeEventListener(EVENT_NAME, listener);
}
